export const generateEventId = () => {
  const random = Math.random().toString(36).substring(2, 8).toUpperCase();
  return `EVT-${Date.now().toString().slice(-6)}${random}`;
};

export const generateInvoiceNumber = (sequence) => {
  return `INV-${String(sequence).padStart(4, "0")}`;
};

export const validateEventData = (data) => {
  const errors = {};
  if (!data.eventDetails?.eventName?.trim()) {
    errors.eventName = "Event name is required";
  }
  if (!data.eventDetails?.eventType) {
    errors.eventType = "Event type is required";
  }
  if (!data.eventDetails?.customer?.customerName?.trim()) {
    errors.customerName = "Customer name is required";
  }
  if (!data.eventDetails?.customer?.phone?.trim()) {
    errors.phone = "Customer phone is required";
  }
  return errors;
};

export const getEventStatusDisplay = (status) => {
  const map = {
    enquiry: { label: "Enquiry", color: "default" },
    confirmed: { label: "Confirmed", color: "info" },
    shooting: { label: "Shooting", color: "warning" },
    editing: { label: "Editing", color: "warning" },
    completed: { label: "Completed", color: "success" },
    cancelled: { label: "Cancelled", color: "error" },
  };
  return map[status] || { label: status, color: "default" };
};

export const calculateBalance = (total = 0, advance = 0) => {
  return Math.max(0, total - advance);
};

export const getPaymentStatus = (total = 0, advance = 0) => {
  if (advance <= 0) return "pending";
  if (advance >= total) return "paid";
  return "partial";
};

export const checkStaffDateConflict = (
  allEvents,
  staffId,
  date,
  excludeEventId = null,
) => {
  return allEvents.some((event) => {
    if (event.id === excludeEventId) return false;
    return event.schedules?.some(
      (s) => s.date === date && s.staffIds?.includes(staffId),
    );
  });
};

export const checkEquipmentDateConflict = (
  allEvents,
  equipmentId,
  date,
  excludeEventId = null,
) => {
  return allEvents.some((event) => {
    if (event.id === excludeEventId) return false;
    const eventDates = event.schedules?.map((s) => s.date) || [];
    if (!eventDates.includes(date)) return false;
    return event.requiredEquipments?.some(
      (eq) => eq.equipmentId === equipmentId && eq.officeTaken && !eq.returned,
    );
  });
};

export const calculateTotalExpenses = (expenses = []) => {
  return expenses.reduce((sum, e) => sum + (e.amount || 0), 0);
};

export const calculateTotalStaffSalary = (staff = []) => {
  return staff.reduce((sum, s) => sum + (s.salary || 0), 0);
};

export const getWorkflowProgress = (workflow = {}) => {
  const steps = Object.keys(workflow);
  if (steps.length === 0) return 0;
  const completed = steps.filter((k) => workflow[k]).length;
  return Math.round((completed / steps.length) * 100);
};

export const formatDate = (dateStr) => {
  if (!dateStr) return "N/A";
  try {
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return dateStr;
  }
};
